import React from 'react';
export class WinnerTableUI extends React.Component {
    constructor(props) {
        super(props);

        this.onViewClick = this.onViewClick.bind(this);
        this.onPrizeClick = this.onPrizeClick.bind(this);
        this.onGhoreClick = this.onGhoreClick.bind(this);
    }
    onViewClick(e) {
        //   console.log("view click");
        if (typeof this.props.onViewClick === "function") {
            this.props.onViewClick(e);

        }
    }


    onPrizeClick(e) {

        //     console.log("prize click");
        if (typeof this.props.onPrizeClick === "function") {
            this.props.onPrizeClick(e);
        }
    }


    onGhoreClick(e) {

        //     console.log("prize click");
        if (typeof this.props.onGhoreClick === "function") {
            this.props.onGhoreClick(e);
        }
    }


    render() {









        if (this.props.data != null && this.props.data.length > 0) {
            var Rows = this.props.data.map(
                (data) =>

                    <tr key={data.winner.id}>
                        <td>
                            {data.prizeName}
                        </td>

                        <td>
                            {data.prizeDescription}
                        </td>

                        
                        <td>
                            {data.ghoreName}
                        </td>
                        <td >
                            {this.props.showMask==true?mphone(data.winner.member.mobileNumber):data.winner.member.mobileNumber}
                        </td>
                    
                        <td>
                            {data.winner.uniqueId}
                        </td>
                        <td>
                            {data.winner.chanceNumber}
                        </td>
                        <td>
                            {data.persianDate}
                        </td>


                    </tr>



            );
        }
        else {
            Rows = <tr><td colSpan="3">سطری وجود ندارد</td></tr>;
        }

        return (
            <div className="col-lg-12">
                <div className="">

                    <div className="table-responsive ">
                        <table className="table  table-striped text-center">
                            <thead>
                                <tr>

                                    <th>
                                        نام جایزه
                                    </th>

                                    
                                    <th>
                                        توضیحات جایزه
                                    </th>

                                    <th>
                                        نام قرعه کشی
                                    </th>
                                    <th >
                                        شماره موبایل
                                    </th>
                                  
                                    <th>
                                        کد
                                    </th>
                                    <th>
شناسه برنده                                    </th>
                                    <th>
                                        تاریخ
                                    </th>


                                </tr>

                            </thead>
                            <tbody>
                                {Rows}
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        );

    }
}
function mphone(v) {
    //var r = v.replace(/\D/g,"");
    var r=v.replace(/^(\d{3})(\d{4})(\d{3}).*/, '$3****$1');
    return r;
}
/*
function printPrice(x) {


    // console.log("x:" + x);
    if (typeof (x) == "undefined")
        return "";

    if (x == null || x === "")
        return "";

    x = parseInt(x);

    return MytoLocaleString(x);
}

function MytoLocaleString(s) {

    var s1 = s.toLocaleString();
    var p = new Number(Math.floor(s) + 0.1);    // similar value but decimal
    var p1 = p.toLocaleString();
    var index;
    var point;
    for (index = p1.length - 1; index > 0; index--) { // find decimal point in dummy
        point = p1.charAt(index);
        if (point < '0' || point > '9')
            break;
    }
    if (index > 0) {
        index = s1.lastIndexOf(point);          // find last point in string
        if (index > 0)
            s1 = s1.slice(0, index);            // truncate decimal part

        return s1;
    }
    return "";
}
*/


// WEBPACK FOOTER //
// ./src/tables/winner/WinnerTableUI.js